<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h5 class="text-center">{{ title }}</h5>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col>
        <p class="text-center">{{ msg }}</p>
      </b-col>
    </b-row>
    <b-row>
      <b-button variant="primary" :to="prev ? prev : '/'">Go Back</b-button>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "ErrPage",
  props: ["msg", "title", "prev"]
};
</script>



// WEBPACK FOOTER //
// src/components/404.vue